/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  PresenterAssignRolesForUserRequest,
  PresenterCreateOfficeUserRequest,
  PresenterError,
  PresenterGetPermissionResponse,
  PresenterIDResponse,
  PresenterInviteUserRequest,
  PresenterOneOfficeUserResponse,
  PresenterResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class OfficeUsers<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Get office user list
   *
   * @tags office_users
   * @name GetCreatableOfficeUsers
   * @summary Get office user list from Navis
   * @request GET:/creatable_office_users
   */
  getCreatableOfficeUsers = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeUserResponse[];
      },
      any
    >({
      path: `/creatable_office_users`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get office users list
   *
   * @tags office_users
   * @name GetOfficeUsers
   * @summary Get office users list
   * @request GET:/office_users
   */
  getOfficeUsers = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeUserResponse[];
      },
      any
    >({
      path: `/office_users`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Create office user
   *
   * @tags office_users
   * @name PostOfficeUsers
   * @summary Create office user
   * @request POST:/office_users
   */
  postOfficeUsers = (
    body: PresenterCreateOfficeUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeUserResponse;
      },
      any
    >({
      path: `/office_users`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Assign roles for office user
   *
   * @tags office_users
   * @name PostOfficeUsersAssignRoles
   * @summary assign roles for office user
   * @request POST:/office_users/assign_roles
   */
  postOfficeUsersAssignRoles = (
    body: PresenterAssignRolesForUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<PresenterResponse, any>({
      path: `/office_users/assign_roles`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description InviteUser office_user
   *
   * @tags office_users
   * @name PostOfficeUsersInvite
   * @summary InviteUser the office_user
   * @request POST:/office_users/invite
   */
  postOfficeUsersInvite = (
    body: PresenterInviteUserRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeUserResponse;
      },
      PresenterError
    >({
      path: `/office_users/invite`,
      method: "POST",
      body: body,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get user permission map
   *
   * @tags office_users
   * @name GetOfficeUsersPermissions
   * @summary Get user permission map
   * @request GET:/office_users/permissions
   */
  getOfficeUsersPermissions = (params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterGetPermissionResponse;
      },
      any
    >({
      path: `/office_users/permissions`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description GetByID office_user
   *
   * @tags office_users
   * @name GetOfficeUsersById
   * @summary GetByID the office_user
   * @request GET:/office_users/{id}
   */
  getOfficeUsersById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterOneOfficeUserResponse;
      },
      PresenterError
    >({
      path: `/office_users/${id}`,
      method: "GET",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete office user by id
   *
   * @tags office_users
   * @name DeleteOfficeUsersById
   * @summary Delete office user
   * @request DELETE:/office_users/{id}
   */
  deleteOfficeUsersById = (id: number, params: RequestParams = {}) =>
    this.http.request<
      PresenterResponse & {
        data?: PresenterIDResponse;
      },
      any
    >({
      path: `/office_users/${id}`,
      method: "DELETE",
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
